import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#272b35] bg-[#0c0d10] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="font-heading text-2xl font-black uppercase text-white">
              Guardia<span className="text-[#E63946]">.</span> Iron Glove
            </div>
            <p className="mt-3 text-sm text-zinc-400 max-w-md leading-relaxed">
              {t("hero_eyebrow")}. Discipline, mechanics & striking science.
            </p>
          </div>
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-3">Menu</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><Link to="/articles" className="hover:text-white">{t("nav_articles")}</Link></li>
              <li><Link to="/reviews" className="hover:text-white">{t("nav_reviews")}</Link></li>
              <li><Link to="/blueprint" className="hover:text-white">{t("nav_blueprint")}</Link></li>
              <li><Link to="/newsletter" className="hover:text-white">{t("nav_newsletter")}</Link></li>
              <li><Link to="/waitlist" className="hover:text-white">{t("nav_waitlist")}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-3">Admin</div>
            <Link to="/login" data-testid="footer-login-link" className="text-sm text-zinc-300 hover:text-white">
              {t("nav_login")}
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#272b35] flex items-start gap-3 text-xs text-zinc-500">
          <AlertTriangle size={16} className="text-[#F59E0B] shrink-0 mt-0.5" />
          <p>{t("footer_disclaimer")}</p>
        </div>
        <p className="mt-4 text-xs text-zinc-600">© {new Date().getFullYear()} Guardia · Iron Glove.</p>
      </div>
    </footer>
  );
};
